
import { Component, Vue, Prop } from "vue-property-decorator"
import FormField from "../../base_classes/FormField"

@Component({
    components: {
        CustomField: () => import("@/components/misc/CustomField.vue"),
        CustomFieldEdit: () => import("@/components/misc/CustomFieldEdit.vue")
    }
})
export default class CustomFieldsField extends FormField {
    @Prop()
    field!: string

    @Prop()
    me?: any

    @Prop({ type: Boolean, default: false })
    hideInternalContractFields?: boolean

    @Prop()
    isNew?: boolean

    @Prop()
    groupUuid?: string

    change(index: number, field: any) {
        if (this.value && this.value[this.field] && this.value[this.field][index]) {
            this.value[this.field][index] = field

            // i hate this
            const { ["__typename"]: _, ...cleanMe } = this.value
            this.value[this.field] = cleanMe[this.field].map((custom: any) => {
                const { ["__typename"]: _, ...cleanCustomFields } = custom
                return cleanCustomFields
            })
            this.$emit("input", this.value)
        }
    }

    canBeSaved() {
        var allCustomFieldsCanBeSaved = true
        if (this.$refs && this.$refs.customFields && typeof this.$refs.customFields == "object") {
            var customFields = Object(this.$refs.customFields)
            for (var customField of customFields) {
                if (!customField.canBeSaved()) allCustomFieldsCanBeSaved = false
            }
        }
        return allCustomFieldsCanBeSaved
    }

    get hasNonNullCustomFields(): boolean {
        return this.value[this.field].filter((field: any) => field.value).length > 0
    }
}
